const findFirst = (arr, cb) => {
  return arr.find(cb)
}

export default findFirst
